import {  useState } from "react";
import {
    Flex,
    Input as ChakraInput,
    Text,
    InputProps as ChakraInputProps,
    Tooltip,
    Icon,
    InputGroup,
    FormControl,
} from "@chakra-ui/react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import parsePhoneNumber from 'libphonenumber-js';
import React from "react";
import pt from 'react-phone-number-input/locale/pt.json';


interface InputProps extends ChakraInputProps {
    type: string;
    name: string;
    countryCodeName?:string;
    valueData?: any;
    defaultValue?: any;
    tooltipText?: string;
    label?: string;
    labelColor?: string;
    register?: any;
    setValue?: any;
    error?: any;
    classInput?: string;
    variant?: string;
    color?: string;
    afterFontSize?: string;
    afterColor?: string;
    afterBackgroundColor?: string;
    trigger?: any;
    isDisabled?: boolean;
}

export function PhoneInput2({
    type,
    name,
    setValue,
    valueData,
    defaultValue,
    countryCodeName,
    tooltipText,
    label,
    labelColor = "gray.600",
    register,
    error,
    classInput,
    variant,
    color,
    afterFontSize = "2xl",
    afterColor = "gray.400",
    afterBackgroundColor = "gray.100",
    trigger,
    isDisabled,
    ...rest
}: InputProps) {
    const [isFocused, setIsFocused] = useState<boolean>(false);
  

    React.useEffect(() => {
        if (defaultValue && !valueData) {
            
            const parsed = parsePhoneNumber(defaultValue);
            if (parsed) {
      
                if (setValue) {
                    setValue("phone", parsed.nationalNumber);
                    setValue("countryCode", parsed.countryCallingCode);
                }
            }
        }
    }, [defaultValue, valueData, setValue]);

    React.useEffect(() => {
        if (isDisabled) {
            const style = document.createElement('style');
            style.textContent = `
                .chakra-input:disabled,
                .PhoneInputInput:disabled,
                .chakra-input[disabled],
                .PhoneInputInput[disabled] {
                    color: #000000 !important;
                    -webkit-text-fill-color: #000000 !important;
                    opacity: 1 !important;
                }
            `;
            document.head.appendChild(style);
            
            return () => {
                document.head.removeChild(style);
            };
        }
    }, [isDisabled]);

    function handleChange(value: string | undefined) {
        if (!setValue) return;
      
        if (!value) {
          setValue(name, "", { shouldDirty: true, shouldValidate: true });
          if (countryCodeName) {
            setValue(countryCodeName, "", { shouldDirty: true, shouldValidate: true });
          }
          trigger?.();
          return;
        }
      
        try {
          const parsed = parsePhoneNumber(value);
          if (parsed) {
            setValue(name, parsed.nationalNumber, { shouldDirty: true, shouldValidate: true });
            if (countryCodeName) {
              setValue(countryCodeName, parsed.countryCallingCode, { shouldDirty: true, shouldValidate: true });
            }
            trigger?.();
          } else {
            // fallback seguro
            setValue(name, "", { shouldDirty: true, shouldValidate: true });
            if (countryCodeName) {
              setValue(countryCodeName, "", { shouldDirty: true, shouldValidate: true });
            }
          }
        } catch {
          setValue(name, "", { shouldDirty: true, shouldValidate: true });
          if (countryCodeName) {
            setValue(countryCodeName, "", { shouldDirty: true, shouldValidate: true });
          }
        }
      }
      



    return (
        <FormControl>
            <Flex flexDir="column">
                <Flex align="center" justify="space-between">
                    <Flex align="center" marginRight={tooltipText ? ".2rem" : ""}>
                        {label && (
                            <Text
                                marginRight={tooltipText ? ".2rem" : ""}
                                marginBottom=".4rem"
                                fontSize=".8rem"
                                color={labelColor}
                            >
                                {label}
                            </Text>
                        )}
                        {tooltipText && (
                            <Tooltip placement="top" hasArrow label={tooltipText}>
                                <span>
                                    <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
                                </span>
                            </Tooltip>
                        )}
                    </Flex>
                </Flex>
                <Flex 
                flexDir="column" 
                border={isDisabled ? "none": isFocused ? "2px solid #3182CE" : "1px solid #ced4da"} 
                align="center"
                alignContent="center"
                alignItems="center"
                p="0"
                h="40px"
                position="relative"
                borderRadius="2px"
                >
                    <InputGroup>
                        {React.createElement(PhoneInput as any, {
                            value: valueData,
                            onChange: handleChange,
                            international: true,
                            limitMaxLength: true,
                            isDisabled: isDisabled,
                            border: "none",
                            labels:pt ,
                            fontSize: "1rem",
                            defaultCountry: "BR",
                            _focus: {
                                borderColor: "transparent",
                                boxShadow: "none",
                            },

                            countryCallingCodeEditable: true,
                            inputComponent: ChakraInput,
                            onFocus: () => setIsFocused(true),
                            onBlur: () => {
                                setIsFocused(false);
                            },
                            style: {
                                borderRadius: "4px",
                                padding: "0 0.6rem",
                                width: "100%",
                                color: isDisabled ? "#000000" : (color || "#52525b !important"),
                                ...(isDisabled && {
                                    color: "#000000 !important",
                                    WebkitTextFillColor: "#000000",
                                    opacity: 1,
                                    "& .chakra-input": {
                                        color: "#000000 !important",
                                        WebkitTextFillColor: "#000000"
                                    },
                                    "& .PhoneInputInput": {
                                        color: "#000000 !important",
                                        WebkitTextFillColor: "#000000"
                                    }
                                })
                            },
                            ...rest
                        })}
                    </InputGroup>
                </Flex>
                {error && (
                    <Text fontSize=".8rem" color="red" mb={error?.message && "4"} role="alert">
                        {error?.message}
                    </Text>
                )}
            </Flex>
        </FormControl>
    );
}
